import ChannelButton from 'components/channel-button/ChannelButton';
import { ToggleGroup, ToggleGroupItem } from 'components/ui/toggle-group';
import React from 'react';
import { AD_CHANNELS } from 'types/adTypes';
import 'twin.macro';
import ToolTip from 'components/tooltip/ToolTip';
import { useVacancyChannelSelection } from 'hooks/useVacancyChannelSelection';
import ChannelChangeRecovery from './ChannelChangeRecovery';

const ChannelToggleGroup: React.FC = () => {
  const {
    channels,
    activeSpending,
    disabled,
    pending,
    unknown,
    failureKnown,
    recoveries,
    vacancyLoading,
    changeChannel,
    retryChange,
  } = useVacancyChannelSelection();
  return (
    <div tw="flex flex-col gap-2">
      <ToggleGroup type="multiple" value={channels}>
        {AD_CHANNELS.map((channel) => (
          <ToolTip
            key={channel}
            text={
              pending
                ? 'Updating channels…'
                : unknown
                ? failureKnown
                  ? 'Retry the previous change or choose a different channel.'
                  : 'Retry the pending channel change to confirm its result.'
                : vacancyLoading
                ? 'Refreshing channels…'
                : activeSpending
                ? `Turn ${
                    channels.includes(channel) ? 'off' : 'on'
                  } ${channel.toLowerCase()}`
                : 'Start campaign in order to toggle individual channels.'
            }
            placement="top"
            arrow
          >
            <ToggleGroupItem
              tw="px-1"
              value={channel}
              disabled={disabled}
              onClick={() => changeChannel(channel)}
            >
              <ChannelButton
                isActive={activeSpending && channels.includes(channel)}
                isToggle
                channelType={channel}
                disabled={disabled}
                grayScale
              />
            </ToggleGroupItem>
          </ToolTip>
        ))}
      </ToggleGroup>
      <ChannelChangeRecovery
        recoveries={recoveries}
        retryChange={retryChange}
      />
    </div>
  );
};

export default ChannelToggleGroup;
